var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.981 5.3a.6.6 0 0 1 .82-.219l6.763 3.914 6.716-3.89a.6.6 0 1 1 .601 1.039l-7.016 4.064a.6.6 0 0 1-.601 0L1.2 6.12a.6.6 0 0 1-.219-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54 9a.6.6 0 0 1 .6.6v7.257a.6.6 0 1 1-1.2 0V9.6a.6.6 0 0 1 .6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.496 17.792c-.713 0-1.417-.155-1.976-.466l-4.323-2.43C1.023 14.24.1 12.66.1 11.301V6.678c0-1.358.923-2.93 2.097-3.593L6.528.671C7.63.049 9.362.041 10.48.663l4.324 2.43c1.174.655 2.097 2.235 2.097 3.593v4.624c0 1.359-.923 2.93-2.097 3.593l-4.324 2.43c-.55.312-1.263.467-1.975.467l-.008-.008Zm0-16.36c-.51 0-1.02.107-1.393.311L2.78 4.166c-.786.442-1.466 1.612-1.466 2.512v4.624c0 .9.688 2.079 1.466 2.513l4.323 2.43c.737.41 2.032.41 2.769 0l4.323-2.43c.786-.442 1.466-1.612 1.466-2.52V6.67c0-.9-.688-2.079-1.466-2.513l-4.323-2.43c-.372-.205-.874-.303-1.376-.303v.008Z"
  }))));
};
export default SvgBox;